import {
  SkeletonProps as MantineSkeletonProps,
  Skeleton as MantineSkeleton,
} from '@mantine/core';

export type SkeletonProps = MantineSkeletonProps;

export const Skeleton = MantineSkeleton;

Skeleton.displayName = 'Skeleton';
